import axios from 'axios';

export default function configureAxios() {
  axios.defaults.headers.get.Accept = 'application/json';

  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        return { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } }
      }

      return config;
    },

    (error) => Promise.reject(error),
  );
}
